import { LikeOutlined } from '@ant-design/icons'
import PropTypes from 'prop-types'
import React from 'react'
import Text from 'components/Text'
import { useTranslation } from 'react-i18next'

import './giveFeedbackWidget.less'

const GiveFeedbackWidget = ({ onClick }) => {
  const { t } = useTranslation()

  return (
    <div className="give-feedback-widget__container" onClick={onClick}>
      <LikeOutlined />
      <Text>{t('portCall.feedback.giveFeedback')}</Text>
    </div>
  )
}

GiveFeedbackWidget.propTypes = {
  onClick: PropTypes.func.isRequired,
}

export default GiveFeedbackWidget
